/**
 * this class created to wrap primitive types for the usage of the widget flow
 */
export class WidgetValueWrapper {
  private value: any;

  constructor(wrappedValue: any) {
    this.value = wrappedValue;
  }
  valueOf() {
      return this.value;
  }
}
